// extracted by css-extract-rspack-plugin
export default {"FormControl":"project-name-editor-module__FormControl__mUdPVj7","TextInput":"project-name-editor-module__TextInput__YrartX_"};